import React from 'react';
import PropTypes from 'prop-types';

const PaymentDistributionRule = ({ rule }) => {
  let displayText = "";  
  switch (rule){
    case 1:
      displayText = "Dráttarvextir fyrst";
      break;
    case 2:
      displayText = "Elsti gjalddagi fyrst";
      break;
    default:
      displayText = "Ekki þekkt tegund";
      break;
  }
  return (
    <span>{displayText}</span>
  );
};

PaymentDistributionRule.propTypes = {
  rule: PropTypes.number,
};

export default PaymentDistributionRule;
